import {ImageSource, type ImageInput} from "@khan/guide-types";

/**
 * Creates a properly typed ImageInput object.
 */
export const createImageInput = (
    dataURL: string,
    source: ImageInput["source"],
    sourceURL?: string,
): ImageInput => {
    const baseImageInput = {
        imageURL: dataURL,
        moderated: false,
    };

    if (source === ImageSource.ProvidedByURL) {
        if (!sourceURL) {
            throw new Error("sourceURL is required for ProvidedByURL");
        }
        return {
            ...baseImageInput,
            source,
            sourceURL,
        };
    }

    return {
        ...baseImageInput,
        source,
    };
};
